import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import conf from 'conf/conf';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7'] as const;

const TariffFAQ = () => {
    const { t } = useTranslation('TariffFAQ');
    const telegramHandle = String(conf.tariffTelegram || '@e_landing');
    const telegramUrl = `https://t.me/${telegramHandle.replace(/^@/, '')}`;

    const renderAnswer = (key: typeof FAQ_KEYS[number]) => {
        const answer = t(`items.${key}.answer`, { defaultValue: '' });

        if (answer) {
            return <p className="text-muted f-12 mb-0">{answer}</p>;
        }

        return (
            <p className="text-muted f-12 mb-0">
                {t(`items.${key}.answerBefore`)}{' '}
                <a
                    href={telegramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fw-medium"
                >
                    {telegramHandle}
                </a>
                {t(`items.${key}.answerAfter`)}
            </p>
        );
    };

    return (
        <Card className="mt-4">
            <Card.Body>
                <h5 className="mb-3 fw-bold">{t('title')}</h5>
                <Accordion flush>
                    {FAQ_KEYS.map((key) => (
                        <Accordion.Item eventKey={key} key={key}>
                            <Accordion.Header className="fs-12 fw-medium">
                                {t(`items.${key}.question`)}
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderAnswer(key)}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Card.Body>
        </Card>
    );
};

export default TariffFAQ;
